const adopt = {
  state: {
    square: null,
    msg_num: 0,
    isfirst: 1,
    square_ktvid: '',
    is_first_noreply: true,
    pointShow: false,
  },
  mutations: {
    SET_SQUARE(state, square) {
      state.square = square;
    },
    SET_SOCKETMSG(state) {
      state.msg_num = ++state.msg_num
    },
    SET_SOCKETMSG_NUM(state) {
      state.isfirst = 0
      state.msg_num = 0
    },
    SET_SQUAREKTVID(state, ktvid) {
      state.square_ktvid = ktvid
    },
    SET_ISFIRST_NOREPLY(state, flag) {
      state.is_first_noreply = flag
    },
    SET_POINTMODAL(state, flag) {
      state.pointShow = flag
    },
  },
};

export default adopt;
